export default {"src":"/_next/static/image/public/images/flags/flag_1869.13a4489ab1321456d8127c0a26edca81.svg","height":16,"width":24};